import { useState, useEffect } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import ThemeMaker from "../../components/thememaker";
import { config } from "../../utils/config";
import CircularProgress from '@mui/material/CircularProgress';
import brandStyles from "../Brand/Brand.module.css";
import styles from "./Rider.module.css";

const { baseNodeapiUrl } = config;

const toastOpts: any = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

function statusPillClass(rawStatus: any) {
    const s = (rawStatus || "").toString().toLowerCase();
    if (["delivered", "approved", "paid", "completed"].some((k) => s.includes(k))) return styles.pillGreen;
    if (["cancelled", "canceled", "rejected", "failed", "not-paid", "not paid"].some((k) => s.includes(k))) return styles.pillRed;
    if (["shipped", "created", "assigned"].some((k) => s.includes(k))) return styles.pillBlue;
    return styles.pillGrey;
}

const RiderOrders = () => {
    const history = useHistory();
    const { id }: any = useParams();
    const [rider, setRider] = useState<any>(null);
    const [orders, setOrders] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchRiderOrders = async () => {
        try {
            setLoading(true);
            const { data } = await axios({
                url: `${baseNodeapiUrl}/invlrider/riderhistory`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: { rider_id: id }
            });
            if (data.success) {
                setRider(data.rider || null);
                setOrders(data.history || []);
            } else {
                toast.error(data.message || "Failed to fetch rider orders !", toastOpts);
            }
        } catch (error) {
            toast.error("Something went wrong while fetching rider orders !", toastOpts);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchRiderOrders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <ThemeMaker>
            <div className={styles.pageWrap}>
                <div className={brandStyles.cardOuter}>
                    <div className={brandStyles.headerBar}>
                        <span className={brandStyles.title}>Rider Orders{rider?.name ? ` — ${rider.name}` : ""}</span>
                        <button className={brandStyles.primaryBtn} onClick={() => history.push('/riderlist')}>Back to Rider List</button>
                    </div>

                    {
                        rider ? (
                            <div className={styles.metaRow}>
                                <span className={styles.metaChip}>WhatsApp: {rider.whatsapp_number}</span>
                                {rider.address ? <span className={styles.metaChip}>Address: {rider.address}</span> : null}
                            </div>
                        ) : null
                    }

                    <div className={`${brandStyles.bodyArea} ${brandStyles.tableWrap}`} style={{ minHeight: "60vh" }}>
                        {
                            loading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
                                    <CircularProgress />
                                </div>
                            ) : orders.length > 0 ? (
                                <table className={styles.premiumTable}>
                                    <thead>
                                        <tr>
                                            <th>Sn.</th>
                                            <th>Order ID</th>
                                            <th>Customer</th>
                                            <th>Contact</th>
                                            <th>Order Status</th>
                                            <th>Payment</th>
                                            <th>Total</th>
                                            <th>Assigned At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            orders.map((item: any, index: number) => (
                                                <tr key={item.id ?? index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <Link to={`/orderCompleteDetail/${item.order_id}`} className={styles.orderLink}>{item.order_id}</Link>
                                                    </td>
                                                    <td>{item.name}</td>
                                                    <td>{item.contact_number}</td>
                                                    <td>
                                                        <span className={`${styles.pillBase} ${statusPillClass(item.order_state)}`}>{item.order_state || "-"}</span>
                                                    </td>
                                                    <td>
                                                        <span className={`${styles.pillBase} ${statusPillClass(item.status)}`}>{item.status || "-"}</span>
                                                    </td>
                                                    <td>{item.order_total ? `₹${item.order_total}` : "-"}</td>
                                                    <td>{item.created_at ? moment.utc(item.created_at).format("DD-MM-YYYY HH:mm") : "-"}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            ) : (
                                <p className={styles.emptyState}>No orders found for this rider !</p>
                            )
                        }
                    </div>
                </div>
            </div>
        </ThemeMaker>
    )
}

export default RiderOrders;
